<template>
  <div class="hb-user-profile-edit-page">
    <div id="user-profile-content">
      <UserProfileHeader title="签证及国籍" :required="true"/>
      <el-descriptions :column="3" border>
        <el-descriptions-item>
          <template slot="label"
            ><span class="require-flag">*</span>
            是否持有申请国家及其他国家的拒签史
          </template>
          <el-radio-group v-model="profile.visa.is_other">
            <el-radio :label="1">否</el-radio>
            <el-radio :label="2">是，若是</el-radio>
          </el-radio-group>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"
            ><span v-if="profile.visa.is_other == 2" class="require-flag"
              >*</span
            >
            签证类型
          </template>
          <el-input
            v-model="profile.visa.visa_type"
            placeholder="请输入签证类型"
            clearable
          >
          </el-input>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="3" border>
        <el-descriptions-item>
          <template slot="label"
            ><span class="require-flag">*</span>
            是否有过其他国家入境、旅游史
          </template>
          <el-radio-group v-model="profile.visa.is_travel_history">
            <el-radio :label="1">否</el-radio>
            <el-radio :label="2">是，若是</el-radio>
          </el-radio-group>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <span
              v-if="profile.visa.is_travel_history == 2"
              class="require-flag"
              >*</span
            >
            国家
          </template>
          <el-input
            v-model="profile.visa.country"
            placeholder="请输入入境国家"
            clearable
          >
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"
            >
            入境及出境日期
          </template>
          <el-input
            v-model="profile.visa.time"
            placeholder="查询护照页或移民局小程序"
            clearable
          >
          </el-input>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="3" border>
        <el-descriptions-item>
          <template slot="label"
            ><span class="require-flag">*</span>
            是否持有其他国家(地区)国籍(身份)
          </template>
          <el-radio-group v-model="profile.visa.is_other_identity">
            <el-radio :label="1">否</el-radio>
            <el-radio :label="2">是，若是</el-radio>
          </el-radio-group>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"
            ><span
              v-if="profile.visa.is_other_identity == 2"
              class="require-flag"
              >*</span
            >
            国家(地区)
          </template>
          <el-input
            v-model="profile.visa.other_identity_country"
            placeholder="请输入持有国籍的国家"
            clearable
          >
          </el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <HBFixedButton
      @click="submitProfile"
      v-loading.fullscreen.lock="from_loading"
      :desc="infoStatusDesc(study_abroad_information_status)"
    />
  </div>
</template>
<script>
import UserProfileHeader from "./userprofile_header.vue";
import { profile_list, profile_update } from "@/api/mycenter_studyabroad";
import HBFixedButton from "../HBCommon/HBFixedButton/HBFixedButton";
import { infoStatusDesc } from "../HBCommon/util";
import { kCacheAbroadInfos } from '../tool';

export default {
  name: "TabTwelve",
  components: {
    UserProfileHeader,
    HBFixedButton,
  },
  data() {
    return {
      defaultProfileData: [],
      from_loading: false,
      study_abroad_information_status: 0,
      profile: {
        visa: {
          country: '',
          is_other: "", //是否持有申请国家及其他国家的拒签史
          visa_type: "", //签证类型
          is_travel_history: "", //是否有过其他国家入境、旅游史
          travel_history_country: "", //入境国家
          time: "", //入境及出境日期
          is_other_identity: "", //是否持有其他国家(地区)国籍(身份)
          other_identity_country: "", //请输入持有国籍的国家
        },
        user_id: "",
        study_abroad_information_status: 0,
      },
    };
  },
  created() {
    this.studentProfile();
  },
  methods: {
    infoStatusDesc(type) {
      return infoStatusDesc(type);
    },
    submitProfile() {
      this.$confirm("是否确认保存？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submitData(3);
        })
        .catch(() => {});
    },
    submitData(val) {
      var rdata = {};
      rdata.type = "va";
      rdata.user_id = this.$route.query.userId;
      rdata.study_abroad_information_status = val;
      rdata.visa = this.profile.visa;
      this.from_loading = true;
      kCacheAbroadInfos(JSON.stringify(rdata))
      profile_update(rdata)
        .then((response) => {
          this.from_loading = false;
          if (response.code === 200) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.studentProfile();
          }
        })
        .catch((error) => {
          this.from_loading = false;
          this.$message.error(error.message);
        });
    },
    studentProfile() {
      profile_list({ user_id: this.$route.query.userId })
        .then((response) => {
          this.defaultProfileData = response.data || [];
          var profile = this.profile;
          // 获取个人绑定信息文稿状态
          if (
            response.data.length &&
            response.data[0].study_abroad_information_va_status
          ) {
            this.study_abroad_information_status =
              response.data[0].study_abroad_information_va_status.status;
          }
          response.data.forEach(function (item, index) {
            var content;
            content = JSON.parse(item.con);
            if (item.class === "other") {
              return;
            }
            if (item.class === "visa") {
              if (content) {
                content.user_information_id = item.id;
                profile.visa = content;
              } else {
                profile.visa.user_information_id = item.id;
              }
            }
          });
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
  }
};
</script>
<style lang="scss" scoped>
.hb-user-profile-edit-page {
  .el-form-item {
    margin-bottom: 0 !important;
  }
  .submit-wrapper {
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .clear {
    clear: both;
  }

  .dynamicTags {
    margin-bottom: 1rem;
    border-bottom: 1px solid #dcdcdc;
    padding-bottom: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .my_content {
      flex: 1;
    }
    .icon {
      width: 50px;
      text-align: center;
      font-weight: 900;
      font-size: 25px;
    }
  }
  .require-flag {
    font-size: 20px !important;
    font-weight: 550 !important;
    color: red !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_twelve.vue